import { find, result } from 'lodash';

// Utility that contains a full list of Categories in AL4.0.
// The Category Object contain properties that can be fetched by calling
// fetchCategoryProperty(categoryId, property)
// Example: Fetch a given Category Icon's ClassName. If Category Id can't be found,
// we default to the generic icon
//   var iconClassName = CategoryUtils.fetchCategoryProperty(-1, 'icon'); // --> 'icon-info-circled'
//   <i className={'icon icon-3x text-info ' + iconClassName}/>

export const categories = [
  {
    id: -1,
    name: { 'en-us': 'Generic' },
    icon: 'icon-info-circled',
  },
  {
    id: 12,
    name: { 'en-us': 'Animal Training' },
    icon: 'icon-pets',
  },
  {
    id: 14,
    name: { 'en-us': 'Appliance Repair - Large' },
    icon: 'icon-repair',
  },
  {
    id: 15,
    name: { 'en-us': 'Auto Body Work' },
    icon: 'icon-automotive',
  },
  {
    id: 16,
    name: { 'en-us': 'Auto Detailing' },
    icon: 'icon-automotive',
  },
  {
    id: 18,
    name: { 'en-us': 'Auto Mufflers' },
    icon: 'icon-automotive',
  },
  {
    id: 19,
    name: { 'en-us': 'Auto Painting' },
    icon: 'icon-automotive',
  },
  {
    id: 20,
    name: { 'en-us': 'Auto Radio Service' },
    icon: 'icon-automotive',
  },
  {
    id: 21,
    name: { 'en-us': 'Auto Service' },
    icon: 'icon-automotive',
  },
  {
    id: 22,
    name: { 'en-us': 'Auto Tires' },
    icon: 'icon-automotive',
  },
  {
    id: 23,
    name: { 'en-us': 'Auto Towing' },
    icon: 'icon-automotive',
  },
  {
    id: 24,
    name: { 'en-us': 'Auto Transmission' },
    icon: 'icon-automotive',
  },
  {
    id: 25,
    name: { 'en-us': 'Awnings' },
    icon: 'icon-home-exterior',
  },
  {
    id: 27,
    name: { 'en-us': 'Basketball Goals' },
    icon: 'icon-home-exterior',
  },
  {
    id: 28,
    name: { 'en-us': 'Bathtub Refinishing & Liners' },
    icon: 'icon-plumbing',
  },
  {
    id: 29,
    name: { 'en-us': 'Bicycles' },
    icon: 'icon-home-exterior',
  },
  {
    id: 30,
    name: { 'en-us': 'Blind Cleaning' },
    icon: 'icon-health',
  },
  {
    id: 31,
    name: { 'en-us': 'Cabinet Making' },
    icon: 'icon-remodeling',
  },
  {
    id: 32,
    name: { 'en-us': 'Cake Decorating' },
    icon: 'icon-food',
  },
  {
    id: 33,
    name: { 'en-us': 'Calligraphy' },
    icon: 'icon-list',
  },
  {
    id: 34,
    name: { 'en-us': 'Camera Repair' },
    icon: 'icon-electrical',
  },
  {
    id: 35,
    name: { 'en-us': 'Carpentry - Unfinished' },
    icon: 'icon-carpentry',
  },
  {
    id: 36,
    name: { 'en-us': 'Carpet Cleaning' },
    icon: 'icon-housecleaning',
  },
  {
    id: 37,
    name: { 'en-us': 'Carpet Sales/Installation/Repair' },
    icon: 'icon-home-interior',
  },
  {
    id: 39,
    name: { 'en-us': 'Catering' },
    icon: 'icon-food',
  },
  {
    id: 40,
    name: { 'en-us': 'Ceramic Tile' },
    icon: 'icon-remodeling',
  },
  {
    id: 41,
    name: { 'en-us': 'Chimney Sweep' },
    icon: 'icon-remodeling',
  },
  {
    id: 42,
    name: { 'en-us': 'Clock Repair' },
    icon: 'icon-repair',
  },
  {
    id: 43,
    name: { 'en-us': 'Closets' },
    icon: 'icon-home-interior',
  },
  {
    id: 44,
    name: { 'en-us': 'Concrete - Pouring & Repair' },
    icon: 'icon-remodeling',
  },
  {
    id: 45,
    name: { 'en-us': 'Costume Rental' },
    icon: 'icon-fabric',
  },
  {
    id: 46,
    name: { 'en-us': 'Countertops' },
    icon: 'icon-home-interior',
  },
  {
    id: 47,
    name: { 'en-us': 'Decks & Porches' },
    icon: 'icon-home-exterior',
  },
  {
    id: 49,
    name: { 'en-us': 'Drapery Cleaning' },
    icon: 'icon-fabric',
  },
  {
    id: 51,
    name: { 'en-us': 'Driveways - Concrete' },
    icon: 'icon-remodeling',
  },
  {
    id: 52,
    name: { 'en-us': 'Dry Cleaning' },
    icon: 'icon-fabric',
  },
  {
    id: 53,
    name: { 'en-us': 'Drywall' },
    icon: 'icon-home-exterior',
  },
  {
    id: 54,
    name: { 'en-us': 'Electrical' },
    icon: 'icon-electrical',
  },
  {
    id: 55,
    name: { 'en-us': 'Windows - Egress' },
    icon: 'icon-windows-doors',
  },
  {
    id: 56,
    name: { 'en-us': 'Entertainment/Parties' },
    icon: 'icon-home-exterior',
  },
  {
    id: 57,
    name: { 'en-us': 'Excavating' },
    icon: 'icon-home-exterior',
  },
  {
    id: 58,
    name: { 'en-us': 'Pest Control/Exterminating' },
    icon: 'icon-home-exterior',
  },
  {
    id: 59,
    name: { 'en-us': 'Fencing' },
    icon: 'icon-home-exterior',
  },
  {
    id: 60,
    name: { 'en-us': 'Film Developing' },
    icon: 'icon-list',
  },
  {
    id: 61,
    name: { 'en-us': 'Firewood' },
    icon: 'icon-home-exterior',
  },
  {
    id: 63,
    name: { 'en-us': 'Flooring Sales/Installation/Repair' },
    icon: 'icon-home-interior',
  },
  {
    id: 64,
    name: { 'en-us': 'Florists' },
    icon: 'icon-list',
  },
  {
    id: 65,
    name: { 'en-us': 'Framing' },
    icon: 'icon-home-exterior',
  },
  {
    id: 67,
    name: { 'en-us': 'Furniture - Refinishing & Repair' },
    icon: 'icon-home-interior',
  },
  {
    id: 68,
    name: { 'en-us': 'Garage Doors' },
    icon: 'icon-home-exterior',
  },
  {
    id: 69,
    name: { 'en-us': 'Garbage Collection' },
    icon: 'icon-home-exterior',
  },
  {
    id: 70,
    name: { 'en-us': 'Gas Grill Repair' },
    icon: 'icon-home-exterior',
  },
  {
    id: 71,
    name: { 'en-us': 'Gifts' },
    icon: 'icon-list',
  },
  {
    id: 72,
    name: { 'en-us': 'Glass & Mirrors' },
    icon: 'icon-home-interior',
  },
  {
    id: 73,
    name: { 'en-us': 'Gutter Cleaning' },
    icon: 'icon-roofing',
  },
  {
    id: 74,
    name: { 'en-us': 'Gutter Repair & Replacement' },
    icon: 'icon-roofing',
  },
  {
    id: 75,
    name: { 'en-us': 'Handymen' },
    icon: 'icon-handyman',
  },
  {
    id: 76,
    name: { 'en-us': 'Hardwood Flooring Sales/Installation/Refinishing' },
    icon: 'icon-home-interior',
  },
  {
    id: 77,
    name: { 'en-us': 'Hauling' },
    icon: 'icon-home-exterior',
  },
  {
    id: 78,
    name: { 'en-us': 'Heating & A/C' },
    icon: 'icon-hvac',
  },
  {
    id: 79,
    name: { 'en-us': 'Home Inspection' },
    icon: 'icon-home-exterior',
  },
  {
    id: 80,
    name: { 'en-us': 'Housecleaning' },
    icon: 'icon-housecleaning',
  },
  {
    id: 81,
    name: { 'en-us': 'Insulation' },
    icon: 'icon-home-exterior',
  },
  {
    id: 82,
    name: { 'en-us': 'Interior Design & Decorating' },
    icon: 'icon-home-interior',
  },
  {
    id: 83,
    name: { 'en-us': 'Jewelry Sales/Design/Repair' },
    icon: 'icon-design',
  },
  {
    id: 84,
    name: { 'en-us': 'Lamp Repair' },
    icon: 'icon-repair',
  },
  {
    id: 85,
    name: { 'en-us': 'Landscaping' },
    icon: 'icon-landscaping',
  },
  {
    id: 86,
    name: { 'en-us': 'Lawn & Yard Work' },
    icon: 'icon-landscaping',
  },
  {
    id: 87,
    name: { 'en-us': 'Lawn Irrigation' },
    icon: 'icon-landscaping',
  },
  {
    id: 88,
    name: { 'en-us': 'Lawn Fertilization & Treatment' },
    icon: 'icon-landscaping',
  },
  {
    id: 89,
    name: { 'en-us': 'Lawn Mower & Power Tool Repair' },
    icon: 'icon-landscaping',
  },
  {
    id: 90,
    name: { 'en-us': 'Leaf Removal' },
    icon: 'icon-landscaping',
  },
  {
    id: 91,
    name: { 'en-us': 'Lighting' },
    icon: 'icon-electrical',
  },
  {
    id: 92,
    name: { 'en-us': 'Limousine Service' },
    icon: 'icon-automotive',
  },
  {
    id: 93,
    name: { 'en-us': 'Locksmiths' },
    icon: 'icon-home-exterior',
  },
  {
    id: 96,
    name: { 'en-us': 'Masonry' },
    icon: 'icon-remodeling',
  },
  {
    id: 98,
    name: { 'en-us': 'Moving' },
    icon: 'icon-moving',
  },
  {
    id: 99,
    name: { 'en-us': 'Mulch & Topsoil' },
    icon: 'icon-landscaping',
  },
  {
    id: 100,
    name: { 'en-us': 'Office Equipment Repair' },
    icon: 'icon-repair',
  },
  {
    id: 102,
    name: { 'en-us': 'Animal & House Sitting' },
    icon: 'icon-pets',
  },
  {
    id: 103,
    name: { 'en-us': 'Photography' },
    icon: 'icon-camera',
  },
  {
    id: 104,
    name: { 'en-us': 'Piano Tuning' },
    icon: 'icon-list',
  },
  {
    id: 105,
    name: { 'en-us': 'Plastering' },
    icon: 'icon-home-exterior',
  },
  {
    id: 106,
    name: { 'en-us': 'Playground Equipment' },
    icon: 'icon-home-exterior',
  },
  {
    id: 107,
    name: { 'en-us': 'Plumbing' },
    icon: 'icon-plumbing',
  },
  {
    id: 108,
    name: { 'en-us': 'Pool & Spa Service and Repair' },
    icon: 'icon-repair',
  },
  {
    id: 110,
    name: { 'en-us': 'Radon Detection & Reduction' },
    icon: 'icon-home-exterior',
  },
  {
    id: 111,
    name: { 'en-us': 'Remodeling - General' },
    icon: 'icon-remodeling',
  },
  {
    id: 112,
    name: { 'en-us': 'Roofing' },
    icon: 'icon-roofing',
  },
  {
    id: 113,
    name: { 'en-us': 'Roto-Tilling' },
    icon: 'icon-landscaping',
  },
  {
    id: 114,
    name: { 'en-us': 'Screen Repair' },
    icon: 'icon-repair',
  },
  {
    id: 115,
    name: { 'en-us': 'Septic Tank' },
    icon: 'icon-plumbing',
  },
  {
    id: 116,
    name: { 'en-us': 'Sewing Machine Repair' },
    icon: 'icon-fabric',
  },
  {
    id: 117,
    name: { 'en-us': 'Shoe Repair' },
    icon: 'icon-fabric',
  },
  {
    id: 119,
    name: { 'en-us': 'Siding' },
    icon: 'icon-home-exterior',
  },
  {
    id: 121,
    name: { 'en-us': 'Appliance Repair - Small' },
    icon: 'icon-repair',
  },
  {
    id: 122,
    name: { 'en-us': 'Stereo & Home Theater Systems' },
    icon: 'icon-electrical',
  },
  {
    id: 123,
    name: { 'en-us': 'Stone & Gravel' },
    icon: 'icon-landscaping',
  },
  {
    id: 125,
    name: { 'en-us': 'Travel Agencies' },
    icon: 'icon-list',
  },
  {
    id: 126,
    name: { 'en-us': 'Tree Service' },
    icon: 'icon-landscaping',
  },
  {
    id: 127,
    name: { 'en-us': 'TV Repair' },
    icon: 'icon-repair',
  },
  {
    id: 128,
    name: { 'en-us': 'Upholstering - General' },
    icon: 'icon-fabric',
  },
  {
    id: 129,
    name: { 'en-us': 'Upholstery Cleaning' },
    icon: 'icon-fabric',
  },
  {
    id: 130,
    name: { 'en-us': 'Vacuum Cleaners' },
    icon: 'icon-home-interior',
  },
  {
    id: 131,
    name: { 'en-us': 'VCR Repair' },
    icon: 'icon-repair',
  },
  {
    id: 132,
    name: { 'en-us': 'Veterinarians' },
    icon: 'icon-pets',
  },
  {
    id: 133,
    name: { 'en-us': 'Video Duplication & Transfer' },
    icon: 'icon-list',
  },
  {
    id: 135,
    name: { 'en-us': 'Wallpaper Removal' },
    icon: 'icon-home-interior',
  },
  {
    id: 136,
    name: { 'en-us': 'Wallpapering' },
    icon: 'icon-home-interior',
  },
  {
    id: 138,
    name: { 'en-us': 'Water & Smoke Damage' },
    icon: 'icon-home-exterior',
  },
  {
    id: 139,
    name: { 'en-us': 'Water Heaters' },
    icon: 'icon-plumbing',
  },
  {
    id: 140,
    name: { 'en-us': 'Water Softeners' },
    icon: 'icon-plumbing',
  },
  {
    id: 142,
    name: { 'en-us': 'Window Cleaning' },
    icon: 'icon-windows-doors',
  },
  {
    id: 143,
    name: { 'en-us': 'Windows' },
    icon: 'icon-windows-doors',
  },
  {
    id: 149,
    name: { 'en-us': 'Basement Waterproofing' },
    icon: 'icon-home-exterior',
  },
  {
    id: 155,
    name: { 'en-us': 'Welding' },
    icon: 'icon-home-exterior',
  },
  {
    id: 157,
    name: { 'en-us': 'Alarms' },
    icon: 'icon-home-exterior',
  },
  {
    id: 159,
    name: { 'en-us': 'Air Duct Cleaning' },
    icon: 'icon-hvac',
  },
  {
    id: 160,
    name: { 'en-us': 'Appraisals - Antiques/Jewelry/Items' },
    icon: 'icon-list',
  },
  {
    id: 161,
    name: { 'en-us': 'Auto Radiators' },
    icon: 'icon-automotive',
  },
  {
    id: 163,
    name: { 'en-us': 'Animal Boarding Kennels' },
    icon: 'icon-pets',
  },
  {
    id: 164,
    name: { 'en-us': 'Upholstering - Boat & Auto' },
    icon: 'icon-fabric',
  },
  {
    id: 165,
    name: { 'en-us': 'Boats' },
    icon: 'icon-water',
  },
  {
    id: 166,
    name: { 'en-us': 'Water Coolers' },
    icon: 'icon-plumbing',
  },
  {
    id: 167,
    name: { 'en-us': 'Buying Services' },
    icon: 'icon-list',
  },
  {
    id: 168,
    name: { 'en-us': 'Camcorder Repair' },
    icon: 'icon-electrical',
  },
  {
    id: 170,
    name: { 'en-us': 'Chimney Caps' },
    icon: 'icon-remodeling',
  },
  {
    id: 171,
    name: { 'en-us': 'Chimney Repair' },
    icon: 'icon-remodeling',
  },
  {
    id: 172,
    name: { 'en-us': 'Computer Repair & Services' },
    icon: 'icon-electrical',
  },
  {
    id: 173,
    name: { 'en-us': 'Computer Training' },
    icon: 'icon-list',
  },
  {
    id: 174,
    name: { 'en-us': 'Deck Maintenance' },
    icon: 'icon-home-exterior',
  },
  {
    id: 175,
    name: { 'en-us': 'Delivery Service' },
    icon: 'icon-list',
  },
  {
    id: 176,
    name: { 'en-us': 'Toy Repair' },
    icon: 'icon-repair',
  },
  {
    id: 178,
    name: { 'en-us': 'Errands' },
    icon: 'icon-list',
  },
  {
    id: 179,
    name: { 'en-us': 'Pressure Washing' },
    icon: 'icon-home-exterior',
  },
  {
    id: 180,
    name: { 'en-us': 'Fireplaces' },
    icon: 'icon-remodeling',
  },
  {
    id: 181,
    name: { 'en-us': 'Furniture - Sales' },
    icon: 'icon-home-interior',
  },
  {
    id: 182,
    name: { 'en-us': 'Furniture - Custom Made' },
    icon: 'icon-home-interior',
  },
  {
    id: 183,
    name: { 'en-us': 'Furs' },
    icon: 'icon-fabric',
  },
  {
    id: 184,
    name: { 'en-us': 'Gas Logs' },
    icon: 'icon-home-interior',
  },
  {
    id: 186,
    name: { 'en-us': 'Printing - Invitations' },
    icon: 'icon-print',
  },
  {
    id: 187,
    name: { 'en-us': 'Ironing' },
    icon: 'icon-fabric',
  },
  {
    id: 189,
    name: { 'en-us': 'Builders - Garages/Barns/Sheds' },
    icon: 'icon-home-exterior',
  },
  {
    id: 190,
    name: { 'en-us': 'Luggage Repair' },
    icon: 'icon-repair',
  },
  {
    id: 191,
    name: { 'en-us': 'Marinas' },
    icon: 'icon-water',
  },
  {
    id: 193,
    name: { 'en-us': 'Mattresses' },
    icon: 'icon-home-interior',
  },
  {
    id: 194,
    name: { 'en-us': 'Mortgage Companies' },
    icon: 'icon-home-exterior',
  },
  {
    id: 195,
    name: { 'en-us': 'Musical Instrument Repair' },
    icon: 'icon-list',
  },
  {
    id: 196,
    name: { 'en-us': 'Builders - Homes' },
    icon: 'icon-home-exterior',
  },
  {
    id: 200,
    name: { 'en-us': 'Reception Halls' },
    icon: 'icon-home-exterior',
  },
  {
    id: 201,
    name: { 'en-us': 'Rentals - Equipment' },
    icon: 'icon-list',
  },
  {
    id: 202,
    name: { 'en-us': 'Resume Services' },
    icon: 'icon-list',
  },
  {
    id: 203,
    name: { 'en-us': 'Roof Ice/Snow Removal' },
    icon: 'icon-roofing',
  },
  {
    id: 205,
    name: { 'en-us': 'TV Service - Satellite' },
    icon: 'icon-list',
  },
  {
    id: 206,
    name: { 'en-us': 'Secretarial Services' },
    icon: 'icon-list',
  },
  {
    id: 207,
    name: { 'en-us': 'Alterations/Sewing/Decorating' },
    icon: 'icon-fabric',
  },
  {
    id: 208,
    name: { 'en-us': 'Skylights' },
    icon: 'icon-windows-doors',
  },
  {
    id: 209,
    name: { 'en-us': 'Snow Removal' },
    icon: 'icon-snow',
  },
  {
    id: 210,
    name: { 'en-us': 'Tablepads' },
    icon: 'icon-home-exterior',
  },
  {
    id: 211,
    name: { 'en-us': 'Phone Wiring' },
    icon: 'icon-electrical',
  },
  {
    id: 212,
    name: { 'en-us': 'Tuxedo Rental' },
    icon: 'icon-fabric',
  },
  {
    id: 213,
    name: { 'en-us': 'TV Antenna' },
    icon: 'icon-list',
  },
  {
    id: 214,
    name: { 'en-us': 'Video Production' },
    icon: 'icon-list',
  },
  {
    id: 216,
    name: { 'en-us': 'Leather & Vinyl Repair' },
    icon: 'icon-fabric',
  },
  {
    id: 217,
    name: { 'en-us': 'Voice Mail' },
    icon: 'icon-list',
  },
  {
    id: 218,
    name: { 'en-us': 'Watch Repair' },
    icon: 'icon-repair',
  },
  {
    id: 220,
    name: { 'en-us': 'Wells & Pumps' },
    icon: 'icon-plumbing',
  },
  {
    id: 221,
    name: { 'en-us': 'Window Tinting' },
    icon: 'icon-automotive',
  },
  {
    id: 222,
    name: { 'en-us': 'Window Treatments' },
    icon: 'icon-windows-doors',
  },
  {
    id: 229,
    name: { 'en-us': 'Tutoring' },
    icon: 'icon-list',
  },
  {
    id: 231,
    name: { 'en-us': 'Holiday Decorating' },
    icon: 'icon-home-exterior',
  },
  {
    id: 235,
    name: { 'en-us': 'Animal Removal' },
    icon: 'icon-pets',
  },
  {
    id: 236,
    name: { 'en-us': 'Animal Grooming' },
    icon: 'icon-pets',
  },
  {
    id: 237,
    name: { 'en-us': 'Auto Sales' },
    icon: 'icon-automotive',
  },
  {
    id: 238,
    name: { 'en-us': 'Appliance Refinishing' },
    icon: 'icon-home-interior',
  },
  {
    id: 239,
    name: { 'en-us': 'Auto Accessories' },
    icon: 'icon-automotive',
  },
  {
    id: 240,
    name: { 'en-us': 'Mailbox Repair' },
    icon: 'icon-home-exterior',
  },
  {
    id: 241,
    name: { 'en-us': 'Organization - Home & Garage' },
    icon: 'icon-home-exterior',
  },
  {
    id: 242,
    name: { 'en-us': 'Carpentry - Woodworking' },
    icon: 'icon-carpentry',
  },
  {
    id: 243,
    name: { 'en-us': 'Wrought Iron' },
    icon: 'icon-home-exterior',
  },
  {
    id: 244,
    name: { 'en-us': 'Mailing Service' },
    icon: 'icon-list',
  },
  {
    id: 246,
    name: { 'en-us': 'Drain Pipe Installation - Exterior' },
    icon: 'icon-plumbing',
  },
  {
    id: 248,
    name: { 'en-us': 'Appliance Sales' },
    icon: 'icon-home-interior',
  },
  {
    id: 249,
    name: { 'en-us': 'Internet Service' },
    icon: 'icon-monitor',
  },
  {
    id: 250,
    name: { 'en-us': 'Ceiling Fans' },
    icon: 'icon-home-interior',
  },
  {
    id: 251,
    name: { 'en-us': 'Funeral Homes' },
    icon: 'icon-list',
  },
  {
    id: 252,
    name: { 'en-us': 'Greenhouses/Nurseries' },
    icon: 'icon-landscaping',
  },
  {
    id: 253,
    name: { 'en-us': 'Manicures/Nails' },
    icon: 'icon-personal-care',
  },
  {
    id: 254,
    name: { 'en-us': 'Accountants/Tax Consultants' },
    icon: 'icon-list',
  },
  {
    id: 258,
    name: { 'en-us': 'Dock Building & Repair' },
    icon: 'icon-water',
  },
  {
    id: 259,
    name: { 'en-us': 'Landscaping - Lakefront' },
    icon: 'icon-landscaping',
  },
  {
    id: 260,
    name: { 'en-us': 'Auto Inspections' },
    icon: 'icon-automotive',
  },
  {
    id: 261,
    name: { 'en-us': 'Hair Salons/Barbers' },
    icon: 'icon-personal-care',
  },
  {
    id: 262,
    name: { 'en-us': 'Marble & Granite' },
    icon: 'icon-remodeling',
  },
  {
    id: 263,
    name: { 'en-us': 'Land Surveying' },
    icon: 'icon-home-exterior',
  },
  {
    id: 264,
    name: { 'en-us': 'Car Washes' },
    icon: 'icon-automotive',
  },
  {
    id: 265,
    name: { 'en-us': 'Fitness - Equipment' },
    icon: 'icon-personal-care',
  },
  {
    id: 266,
    name: { 'en-us': 'Trophy Shops' },
    icon: 'icon-list',
  },
  {
    id: 267,
    name: { 'en-us': 'Bridal Shops' },
    icon: 'icon-fabric',
  },
  {
    id: 268,
    name: { 'en-us': 'Structural Engineering' },
    icon: 'icon-home-exterior',
  },
  {
    id: 269,
    name: { 'en-us': 'Architects & Building Design' },
    icon: 'icon-home-exterior',
  },
  {
    id: 270,
    name: { 'en-us': 'Stucco' },
    icon: 'icon-home-exterior',
  },
  {
    id: 271,
    name: { 'en-us': 'Signs' },
    icon: 'icon-list',
  },
  {
    id: 272,
    name: { 'en-us': 'Antiques' },
    icon: 'icon-home-interior',
  },
  {
    id: 273,
    name: { 'en-us': 'Warranty Companies - Home' },
    icon: 'icon-home-exterior',
  },
  {
    id: 274,
    name: { 'en-us': 'Financial Planning' },
    icon: 'icon-list',
  },
  {
    id: 275,
    name: { 'en-us': 'Wedding Planning' },
    icon: 'icon-list',
  },
  {
    id: 277,
    name: { 'en-us': 'Chefs' },
    icon: 'icon-food',
  },
  {
    id: 278,
    name: { 'en-us': 'Artwork/Murals' },
    icon: 'icon-design',
  },
  {
    id: 279,
    name: { 'en-us': 'Auction Services' },
    icon: 'icon-list',
  },
  {
    id: 280,
    name: { 'en-us': 'Appraisals - Real Estate' },
    icon: 'icon-home-exterior',
  },
  {
    id: 281,
    name: { 'en-us': 'Music Instruction' },
    icon: 'icon-list',
  },
  {
    id: 282,
    name: { 'en-us': 'Billiard Table Repair' },
    icon: 'icon-home-interior',
  },
  {
    id: 283,
    name: { 'en-us': 'Glass Block' },
    icon: 'icon-home-exterior',
  },
  {
    id: 284,
    name: { 'en-us': 'Sharpening' },
    icon: 'icon-home-exterior',
  },
  {
    id: 286,
    name: { 'en-us': 'Buffing & Polishing' },
    icon: 'icon-home-interior',
  },
  {
    id: 287,
    name: { 'en-us': 'Fitness - Training' },
    icon: 'icon-personal-care',
  },
  {
    id: 288,
    name: { 'en-us': 'Fitness - Centers' },
    icon: 'icon-personal-care',
  },
  {
    id: 289,
    name: { 'en-us': 'Dumpster Service' },
    icon: 'icon-home-exterior',
  },
  {
    id: 291,
    name: { 'en-us': 'Remodeling - Kitchen & Bathroom' },
    icon: 'icon-remodeling',
  },
  {
    id: 293,
    name: { 'en-us': 'Painting - Exterior' },
    icon: 'icon-painting',
  },
  {
    id: 294,
    name: { 'en-us': 'Painting - Interior' },
    icon: 'icon-painting',
  },
  {
    id: 295,
    name: { 'en-us': 'Private Investigation' },
    icon: 'icon-list',
  },
  {
    id: 296,
    name: { 'en-us': 'Insurance Agencies' },
    icon: 'icon-list',
  },
  {
    id: 297,
    name: { 'en-us': 'Billiard Table Sales' },
    icon: 'icon-home-interior',
  },
  {
    id: 298,
    name: { 'en-us': 'Computer Sales' },
    icon: 'icon-list',
  },
  {
    id: 322,
    name: { 'en-us': 'Animal Fencing' },
    icon: 'icon-pets',
  },
  {
    id: 324,
    name: { 'en-us': 'Uncategorized Services' },
    icon: 'icon-info-circled',
  },
  {
    id: 330,
    name: { 'en-us': 'Gas Leak Repair' },
    icon: 'icon-home-exterior',
  },
  {
    id: 333,
    name: { 'en-us': 'Cabinet Refacing/Restoration' },
    icon: 'icon-remodeling',
  },
  {
    id: 336,
    name: { 'en-us': 'Fountains' },
    icon: 'icon-home-exterior',
  },
  {
    id: 337,
    name: { 'en-us': 'Taxi/Shuttle Service' },
    icon: 'icon-automotive',
  },
  {
    id: 351,
    name: { 'en-us': 'Storage Facilities' },
    icon: 'icon-moving',
  },
  {
    id: 368,
    name: { 'en-us': 'China Repair' },
    icon: 'icon-home-interior',
  },
  {
    id: 369,
    name: { 'en-us': 'Asbestos Removal' },
    icon: 'icon-home-exterior',
  },
  {
    id: 370,
    name: { 'en-us': 'Metal Fabrication & Restoration' },
    icon: 'icon-home-exterior',
  },
  {
    id: 371,
    name: { 'en-us': 'Sewer Cleaning' },
    icon: 'icon-plumbing',
  },
  {
    id: 372,
    name: { 'en-us': 'Drivers Education' },
    icon: 'icon-list',
  },
  {
    id: 373,
    name: { 'en-us': 'Ticket Broker Service' },
    icon: 'icon-list',
  },
  {
    id: 375,
    name: { 'en-us': 'Auto Alarms' },
    icon: 'icon-automotive',
  },
  {
    id: 376,
    name: { 'en-us': 'Auto Glass' },
    icon: 'icon-automotive',
  },
  {
    id: 377,
    name: { 'en-us': 'Doors' },
    icon: 'icon-windows-doors',
  },
  {
    id: 378,
    name: { 'en-us': 'Piano Moving' },
    icon: 'icon-moving',
  },
  {
    id: 379,
    name: { 'en-us': 'Rentals - Parties' },
    icon: 'icon-list',
  },
  {
    id: 380,
    name: { 'en-us': 'Floor Cleaning/Polishing/Waxing' },
    icon: 'icon-housecleaning',
  },
  {
    id: 381,
    name: { 'en-us': 'Driveways - Asphalt' },
    icon: 'icon-remodeling',
  },
  {
    id: 382,
    name: { 'en-us': 'Printing - Copies' },
    icon: 'icon-print',
  },
  {
    id: 383,
    name: { 'en-us': 'Plumbing - Drain Cleaning' },
    icon: 'icon-plumbing',
  },
  {
    id: 384,
    name: { 'en-us': 'Remodeling - Sunrooms & Patio Enclosures' },
    icon: 'icon-remodeling',
  },
  {
    id: 385,
    name: { 'en-us': 'Concrete - Leveling/Mudjacking' },
    icon: 'icon-remodeling',
  },
  {
    id: 386,
    name: { 'en-us': 'Home Healthcare - Disability Equipment & Services' },
    icon: 'icon-health',
  },
  {
    id: 387,
    name: { 'en-us': 'Hardware & Home Improvement Stores' },
    icon: 'icon-home-exterior',
  },
  {
    id: 388,
    name: { 'en-us': 'Dog Walking' },
    icon: 'icon-pets',
  },
  {
    id: 389,
    name: { 'en-us': 'Childproofing' },
    icon: 'icon-childcare',
  },
  {
    id: 390,
    name: { 'en-us': 'Solar Panels' },
    icon: 'icon-home-exterior',
  },
  {
    id: 391,
    name: { 'en-us': 'Misting Systems' },
    icon: 'icon-landscaping',
  },
  {
    id: 392,
    name: { 'en-us': 'Roof Cleaning' },
    icon: 'icon-roofing',
  },
  {
    id: 393,
    name: { 'en-us': 'Windows - Safety & Security Film' },
    icon: 'icon-windows-doors',
  },
  {
    id: 394,
    name: { 'en-us': 'Hurricane Shutters' },
    icon: 'icon-home-exterior',
  },
  {
    id: 395,
    name: { 'en-us': 'Real Estate Agents' },
    icon: 'icon-home-exterior',
  },
  {
    id: 396,
    name: { 'en-us': 'Pooper Scoopers' },
    icon: 'icon-pets',
  },
  {
    id: 397,
    name: { 'en-us': 'Paper Shredding' },
    icon: 'icon-list',
  },
  {
    id: 398,
    name: { 'en-us': 'Warranty Companies - Non-Home' },
    icon: 'icon-list',
  },
  {
    id: 399,
    name: { 'en-us': 'Motorcycle Service' },
    icon: 'icon-automotive',
  },
  {
    id: 400,
    name: { 'en-us': 'Dance Instruction' },
    icon: 'icon-list',
  },
  {
    id: 401,
    name: { 'en-us': 'Rentals - Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 402,
    name: { 'en-us': 'Rentals - Trucks' },
    icon: 'icon-automotive',
  },
  {
    id: 403,
    name: { 'en-us': 'Rentals - Vans' },
    icon: 'icon-automotive',
  },
  {
    id: 404,
    name: { 'en-us': 'Auto Transportation' },
    icon: 'icon-automotive',
  },
  {
    id: 405,
    name: { 'en-us': 'Tanning Salons' },
    icon: 'icon-personal-care',
  },
  {
    id: 406,
    name: { 'en-us': 'Title Companies' },
    icon: 'icon-list',
  },
  {
    id: 407,
    name: { 'en-us': 'Mold Testing & Remediation' },
    icon: 'icon-home-exterior',
  },
  {
    id: 408,
    name: { 'en-us': 'Child Care - Center' },
    icon: 'icon-childcare',
  },
  {
    id: 409,
    name: { 'en-us': 'Child Care - Family/In Provider Home' },
    icon: 'icon-childcare',
  },
  {
    id: 410,
    name: { 'en-us': 'Child Care - Other' },
    icon: 'icon-childcare',
  },
  {
    id: 411,
    name: { 'en-us': 'TV Service - Cable' },
    icon: 'icon-list',
  },
  {
    id: 412,
    name: { 'en-us': 'TV Sales' },
    icon: 'icon-list',
  },
  {
    id: 413,
    name: { 'en-us': 'Phone Service - Cellular' },
    icon: 'icon-list',
  },
  {
    id: 414,
    name: { 'en-us': 'Phone Service - Landline' },
    icon: 'icon-list',
  },
  {
    id: 415,
    name: { 'en-us': 'Phone Repair' },
    icon: 'icon-electrical',
  },
  {
    id: 416,
    name: { 'en-us': 'Phone Sales' },
    icon: 'icon-list',
  },
  {
    id: 417,
    name: { 'en-us': 'Longterm Care - Adult Daycare' },
    icon: 'icon-health',
  },
  {
    id: 418,
    name: { 'en-us': 'Longterm Care - Assisted Living' },
    icon: 'icon-health',
  },
  {
    id: 419,
    name: { 'en-us': 'Home Healthcare - Independent Living' },
    icon: 'icon-health',
  },
  {
    id: 420,
    name: { 'en-us': 'Home Healthcare - In-home Services' },
    icon: 'icon-health',
  },
  {
    id: 421,
    name: { 'en-us': 'Longterm Care - Nursing Homes' },
    icon: 'icon-health',
  },
  {
    id: 422,
    name: { 'en-us': 'Home Staging' },
    icon: 'icon-home-interior',
  },
  {
    id: 423,
    name: { 'en-us': 'Hospitals - General' },
    icon: 'icon-health',
  },
  {
    id: 424,
    name: { 'en-us': 'Outpatient Centers - Urgent Care' },
    icon: 'icon-health',
  },
  {
    id: 425,
    name: { 'en-us': 'Health Insurance - Agents & Companies' },
    icon: 'icon-health',
  },
  {
    id: 427,
    name: { 'en-us': 'Eye Care - Optical Sales & Repair' },
    icon: 'icon-health',
  },
  {
    id: 428,
    name: { 'en-us': 'Pharmacies' },
    icon: 'icon-health',
  },
  {
    id: 429,
    name: { 'en-us': 'Allergy & Immunology' },
    icon: 'icon-health',
  },
  {
    id: 430,
    name: { 'en-us': 'Heart Care - Cardiovascular Surgery' },
    icon: 'icon-health',
  },
  {
    id: 431,
    name: { 'en-us': 'Heart Care - General Cardiology' },
    icon: 'icon-health',
  },
  {
    id: 432,
    name: { 'en-us': 'Heart Care - Interventional Cardiology' },
    icon: 'icon-health',
  },
  {
    id: 433,
    name: { 'en-us': 'Chiropractic Care' },
    icon: 'icon-health',
  },
  {
    id: 434,
    name: { 'en-us': 'Dentistry - Root Canals/Endodontics' },
    icon: 'icon-dentistry',
  },
  {
    id: 435,
    name: { 'en-us': 'Dentistry - General' },
    icon: 'icon-dentistry',
  },
  {
    id: 436,
    name: { 'en-us': 'Dentistry - Oral & Maxillofacial Surgery' },
    icon: 'icon-dentistry',
  },
  {
    id: 437,
    name: { 'en-us': 'Dentistry - Orthodontics' },
    icon: 'icon-dentistry',
  },
  {
    id: 438,
    name: { 'en-us': 'Dentistry - Gum Care/Periodontics' },
    icon: 'icon-dentistry',
  },
  {
    id: 439,
    name: { 'en-us': 'Dermatology - General' },
    icon: 'icon-health',
  },
  {
    id: 440,
    name: { 'en-us': 'Ear, Nose & Throat/Otolaryngology' },
    icon: 'icon-health',
  },
  {
    id: 441,
    name: { 'en-us': 'Endocrinology & Metabolism' },
    icon: 'icon-health',
  },
  {
    id: 442,
    name: { 'en-us': 'Digestive Care/Gastroenterology' },
    icon: 'icon-health',
  },
  {
    id: 443,
    name: { 'en-us': 'General Surgery' },
    icon: 'icon-health',
  },
  {
    id: 444,
    name: { 'en-us': 'Neuroscience - Neurology' },
    icon: 'icon-health',
  },
  {
    id: 445,
    name: { 'en-us': 'Women\'s Services - Obstetrics & Gynecology' },
    icon: 'icon-health',
  },
  {
    id: 446,
    name: { 'en-us': 'Cancer/Oncology' },
    icon: 'icon-health',
  },
  {
    id: 447,
    name: { 'en-us': 'Eye Care - Ophthalmology' },
    icon: 'icon-health',
  },
  {
    id: 448,
    name: { 'en-us': 'Eye Care - Optometry' },
    icon: 'icon-health',
  },
  {
    id: 449,
    name: { 'en-us': 'Orthopedics' },
    icon: 'icon-health',
  },
  {
    id: 450,
    name: { 'en-us': 'Allergy & Immunology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 451,
    name: { 'en-us': 'Heart Care - Pediatric Cardiology' },
    icon: 'icon-health',
  },
  {
    id: 452,
    name: { 'en-us': 'Dentistry - Pediatrics' },
    icon: 'icon-dentistry',
  },
  {
    id: 453,
    name: { 'en-us': 'Dermatology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 454,
    name: { 'en-us': 'Ear, Nose & Throat - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 455,
    name: { 'en-us': 'Endocrinology & Metabolism - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 456,
    name: { 'en-us': 'Digestive Care/Gastroenterology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 457,
    name: { 'en-us': 'General Surgery - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 458,
    name: { 'en-us': 'Neuroscience - Pediatric Neurology' },
    icon: 'icon-health',
  },
  {
    id: 459,
    name: { 'en-us': 'Cancer/Oncology - Pediatric' },
    icon: 'icon-health',
  },
  {
    id: 460,
    name: { 'en-us': 'Eye Care - Pediatric Ophthalmology' },
    icon: 'icon-health',
  },
  {
    id: 461,
    name: { 'en-us': 'Eye Care - Pediatric Optometry' },
    icon: 'icon-health',
  },
  {
    id: 462,
    name: { 'en-us': 'Orthopedics - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 463,
    name: { 'en-us': 'Pediatrics - Primary Care' },
    icon: 'icon-health',
  },
  {
    id: 464,
    name: { 'en-us': 'Rehabilitation - Physical Therapy' },
    icon: 'icon-health',
  },
  {
    id: 466,
    name: { 'en-us': 'Plastic Surgery - Cosmetic' },
    icon: 'icon-health',
  },
  {
    id: 467,
    name: { 'en-us': 'Plastic Surgery - Reconstructive' },
    icon: 'icon-health',
  },
  {
    id: 468,
    name: { 'en-us': 'Mental Health - Psychiatry' },
    icon: 'icon-health',
  },
  {
    id: 469,
    name: { 'en-us': 'Mental Health - Psychology' },
    icon: 'icon-health',
  },
  {
    id: 470,
    name: { 'en-us': 'Sports Medicine' },
    icon: 'icon-health',
  },
  {
    id: 471,
    name: { 'en-us': 'Urology' },
    icon: 'icon-health',
  },
  {
    id: 472,
    name: { 'en-us': 'Vascular Surgery' },
    icon: 'icon-health',
  },
  {
    id: 478,
    name: { 'en-us': 'Unrated Medical Services' },
    icon: 'icon-health',
  },
  {
    id: 479,
    name: { 'en-us': 'Lead Testing & Removal' },
    icon: 'icon-home-exterior',
  },
  {
    id: 481,
    name: { 'en-us': 'Pet Insurance' },
    icon: 'icon-pets',
  },
  {
    id: 482,
    name: { 'en-us': 'Foundation Repair' },
    icon: 'icon-home-exterior',
  },
  {
    id: 483,
    name: { 'en-us': 'Earthquake Retrofitting' },
    icon: 'icon-home-exterior',
  },
  {
    id: 484,
    name: { 'en-us': 'Dryer Vent Cleaning' },
    icon: 'icon-home-exterior',
  },
  {
    id: 485,
    name: { 'en-us': 'Dentistry - Cosmetic' },
    icon: 'icon-dentistry',
  },
  {
    id: 486,
    name: { 'en-us': 'Alternative Med. - Acupuncture' },
    icon: 'icon-health',
  },
  {
    id: 487,
    name: { 'en-us': 'Anesthesiology' },
    icon: 'icon-health',
  },
  {
    id: 488,
    name: { 'en-us': 'Ear Nose & Throat - Hearing Tests/Audiology' },
    icon: 'icon-health',
  },
  {
    id: 489,
    name: { 'en-us': 'Alternative Med. - General' },
    icon: 'icon-health',
  },
  {
    id: 490,
    name: { 'en-us': 'Dentistry - Dentures/Prosthodontics' },
    icon: 'icon-dentistry',
  },
  {
    id: 491,
    name: { 'en-us': 'Dentistry - Denture Labs' },
    icon: 'icon-dentistry',
  },
  {
    id: 492,
    name: { 'en-us': 'Women\'s Services - Doulas' },
    icon: 'icon-health',
  },
  {
    id: 493,
    name: { 'en-us': 'Hospitals - Emergency Medicine' },
    icon: 'icon-health',
  },
  {
    id: 494,
    name: { 'en-us': 'Women\'s services - Fertility' },
    icon: 'icon-health',
  },
  {
    id: 495,
    name: { 'en-us': 'Primary Care - Geriatrics' },
    icon: 'icon-health',
  },
  {
    id: 496,
    name: { 'en-us': 'Ear Nose & Throat - Hearing Aids' },
    icon: 'icon-health',
  },
  {
    id: 497,
    name: { 'en-us': 'Kidney Care/nephrology' },
    icon: 'icon-health',
  },
  {
    id: 498,
    name: { 'en-us': 'Massage Therapy' },
    icon: 'icon-personal-care',
  },
  {
    id: 499,
    name: { 'en-us': 'Women\'s services - Midwives' },
    icon: 'icon-health',
  },
  {
    id: 500,
    name: { 'en-us': 'Neuroscience - Neurosurgery' },
    icon: 'icon-health',
  },
  {
    id: 501,
    name: { 'en-us': 'Nurse Practitioners' },
    icon: 'icon-health',
  },
  {
    id: 502,
    name: { 'en-us': 'Orthopedics - Foot & Ankle' },
    icon: 'icon-health',
  },
  {
    id: 503,
    name: { 'en-us': 'Orthopedics - Hand & Wrist' },
    icon: 'icon-health',
  },
  {
    id: 504,
    name: { 'en-us': 'Orthopedics - Hips' },
    icon: 'icon-health',
  },
  {
    id: 505,
    name: { 'en-us': 'Orthopedics - Knee & Leg' },
    icon: 'icon-health',
  },
  {
    id: 506,
    name: { 'en-us': 'Orthopedics - Shoulder & Arm' },
    icon: 'icon-health',
  },
  {
    id: 507,
    name: { 'en-us': 'Orthopedics - Spine & Neck' },
    icon: 'icon-health',
  },
  {
    id: 508,
    name: { 'en-us': 'Genealogy' },
    icon: 'icon-list',
  },
  {
    id: 509,
    name: { 'en-us': 'Pain Management' },
    icon: 'icon-health',
  },
  {
    id: 510,
    name: { 'en-us': 'Kidney Care/nephrology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 511,
    name: { 'en-us': 'Imaging - Pediatric Radiology' },
    icon: 'icon-health',
  },
  {
    id: 512,
    name: { 'en-us': 'Sports Medicine - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 513,
    name: { 'en-us': 'Urology - Pediatric Urology' },
    icon: 'icon-health',
  },
  {
    id: 514,
    name: { 'en-us': 'Rehabilitation - Physical Medicine & Rehab' },
    icon: 'icon-health',
  },
  {
    id: 515,
    name: { 'en-us': 'Foot & Ankle Care' },
    icon: 'icon-health',
  },
  {
    id: 516,
    name: { 'en-us': 'Foot Care - Prosthetics & Orthotics' },
    icon: 'icon-health',
  },
  {
    id: 517,
    name: { 'en-us': 'Lung/Pulmonology' },
    icon: 'icon-health',
  },
  {
    id: 518,
    name: { 'en-us': 'Primary Care - Family Medicine' },
    icon: 'icon-health',
  },
  {
    id: 519,
    name: { 'en-us': 'Primary Care - Internal Medicine' },
    icon: 'icon-health',
  },
  {
    id: 520,
    name: { 'en-us': 'Energy Efficiency Auditing' },
    icon: 'icon-home-exterior',
  },
  {
    id: 521,
    name: { 'en-us': 'Baby Equipment Rental' },
    icon: 'icon-childcare',
  },
  {
    id: 522,
    name: { 'en-us': 'Counseling - General' },
    icon: 'icon-health',
  },
  {
    id: 523,
    name: { 'en-us': 'Weight Mgt. - Dietitians/Nutritionists' },
    icon: 'icon-health',
  },
  {
    id: 524,
    name: { 'en-us': 'Lab Services - Blood Work' },
    icon: 'icon-health',
  },
  {
    id: 525,
    name: { 'en-us': 'Home Healthcare - Medical Equipment & Services' },
    icon: 'icon-health',
  },
  {
    id: 526,
    name: { 'en-us': 'Weight management - Vitamin & Supplement Stores' },
    icon: 'icon-health',
  },
  {
    id: 530,
    name: { 'en-us': 'Rheumatology' },
    icon: 'icon-health',
  },
  {
    id: 531,
    name: { 'en-us': 'Sleep Medicine' },
    icon: 'icon-health',
  },
  {
    id: 532,
    name: { 'en-us': 'Alternative Med. - Traditional Chinese Medicine' },
    icon: 'icon-health',
  },
  {
    id: 533,
    name: { 'en-us': 'Propane Sales/Services' },
    icon: 'icon-home-exterior',
  },
  {
    id: 534,
    name: { 'en-us': 'Property Management' },
    icon: 'icon-home-exterior',
  },
  {
    id: 535,
    name: { 'en-us': 'Landscaping - Hardscaping & Pavers' },
    icon: 'icon-landscaping',
  },
  {
    id: 536,
    name: { 'en-us': 'Uncategorized' },
    icon: 'icon-info-circled',
  },
  {
    id: 539,
    name: { 'en-us': 'Speech Therapy' },
    icon: 'icon-health',
  },
  {
    id: 540,
    name: { 'en-us': 'Imaging - Ultrasound Diagnostics' },
    icon: 'icon-health',
  },
  {
    id: 541,
    name: { 'en-us': 'Women\'s Services - Breast Surgery' },
    icon: 'icon-health',
  },
  {
    id: 542,
    name: { 'en-us': 'Gastroenterology - Colon & Rectal Care' },
    icon: 'icon-health',
  },
  {
    id: 543,
    name: { 'en-us': 'Health Education/Workshops' },
    icon: 'icon-health',
  },
  {
    id: 544,
    name: { 'en-us': 'Blood Care/Hematology' },
    icon: 'icon-health',
  },
  {
    id: 545,
    name: { 'en-us': 'Infectious Diseases' },
    icon: 'icon-health',
  },
  {
    id: 546,
    name: { 'en-us': 'Lab Services - Diagnostic' },
    icon: 'icon-health',
  },
  {
    id: 547,
    name: { 'en-us': 'Travel Medicine' },
    icon: 'icon-health',
  },
  {
    id: 548,
    name: { 'en-us': 'Dentistry - TMJ' },
    icon: 'icon-dentistry',
  },
  {
    id: 549,
    name: { 'en-us': 'Tattoos/Piercings' },
    icon: 'icon-personal-care',
  },
  {
    id: 550,
    name: { 'en-us': 'Hair Removal ' },
    icon: 'icon-personal-care',
  },
  {
    id: 551,
    name: { 'en-us': 'Ambulance Services' },
    icon: 'icon-health',
  },
  {
    id: 552,
    name: { 'en-us': 'Weight Mgt. - Bariatric Medicine' },
    icon: 'icon-health',
  },
  {
    id: 554,
    name: { 'en-us': 'Lab Services - Blood Banks' },
    icon: 'icon-health',
  },
  {
    id: 555,
    name: { 'en-us': 'Skin & Body Care - Colonic Irrigation' },
    icon: 'icon-health',
  },
  {
    id: 556,
    name: { 'en-us': 'Counseling - Family' },
    icon: 'icon-health',
  },
  {
    id: 557,
    name: { 'en-us': 'Longterm Care - Hospice Facilities' },
    icon: 'icon-health',
  },
  {
    id: 558,
    name: { 'en-us': 'Alternative Med. - Hypnotherapy' },
    icon: 'icon-health',
  },
  {
    id: 559,
    name: { 'en-us': 'Home Healthcare - Medical Alert Systems' },
    icon: 'icon-health',
  },
  {
    id: 560,
    name: { 'en-us': 'Rehabilitation - Occupational Therapy' },
    icon: 'icon-health',
  },
  {
    id: 561,
    name: { 'en-us': 'Mental Health - Alcohol Treatment Centers' },
    icon: 'icon-health',
  },
  {
    id: 562,
    name: { 'en-us': 'Mental Health - Drug Abuse Treatment Centers' },
    icon: 'icon-health',
  },
  {
    id: 563,
    name: { 'en-us': 'Skin & Body Care - Day Spa Services' },
    icon: 'icon-personal-care',
  },
  {
    id: 564,
    name: { 'en-us': 'Weight management - Weight Loss Programs' },
    icon: 'icon-personal-care',
  },
  {
    id: 566,
    name: { 'en-us': 'Skin & Body Care - Aromatherapy' },
    icon: 'icon-personal-care',
  },
  {
    id: 567,
    name: { 'en-us': 'Women\'s services - Birth Control & Family Planning' },
    icon: 'icon-health',
  },
  {
    id: 568,
    name: { 'en-us': 'Counseling - Addiction' },
    icon: 'icon-health',
  },
  {
    id: 569,
    name: { 'en-us': 'Counseling - Grief' },
    icon: 'icon-health',
  },
  {
    id: 570,
    name: { 'en-us': 'Counseling - Marriage/Relationship' },
    icon: 'icon-health',
  },
  {
    id: 571,
    name: { 'en-us': 'Lab Services - Drug & Alcohol Testing' },
    icon: 'icon-health',
  },
  {
    id: 572,
    name: { 'en-us': 'Genetic Medicine' },
    icon: 'icon-health',
  },
  {
    id: 573,
    name: { 'en-us': 'Hair - Replacement & Transplants' },
    icon: 'icon-personal-care',
  },
  {
    id: 574,
    name: { 'en-us': 'Liver Care/Hepatology' },
    icon: 'icon-health',
  },
  {
    id: 575,
    name: { 'en-us': 'Home Healthcare - Hospice' },
    icon: 'icon-health',
  },
  {
    id: 576,
    name: { 'en-us': 'Hospitals - Children\'s' },
    icon: 'icon-health',
  },
  {
    id: 577,
    name: { 'en-us': 'Hospitals - Intensive Care' },
    icon: 'icon-health',
  },
  {
    id: 578,
    name: { 'en-us': 'Heart Care - Pediatric Cardiovascular Surgery' },
    icon: 'icon-health',
  },
  {
    id: 579,
    name: { 'en-us': 'Blood Care/Hematology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 580,
    name: { 'en-us': 'Lung/Pulmonology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 581,
    name: { 'en-us': 'Rheumatology - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 582,
    name: { 'en-us': 'Chest/Thoracic Surgery - Pediatrics' },
    icon: 'icon-health',
  },
  {
    id: 583,
    name: { 'en-us': 'Massage Therapy - Reflexology' },
    icon: 'icon-personal-care',
  },
  {
    id: 584,
    name: { 'en-us': 'Chest/Thoracic Surgery' },
    icon: 'icon-health',
  },
  {
    id: 585,
    name: { 'en-us': 'Transplant Surgery' },
    icon: 'icon-health',
  },
  {
    id: 588,
    name: { 'en-us': 'Patient Advocates' },
    icon: 'icon-health',
  },
  {
    id: 591,
    name: { 'en-us': 'Epoxy Flooring' },
    icon: 'icon-home-interior',
  },
  {
    id: 592,
    name: { 'en-us': 'Home Automation' },
    icon: 'icon-home-exterior',
  },
  {
    id: 593,
    name: { 'en-us': 'Electronic Gadget Repair' },
    icon: 'icon-electrical',
  },
  {
    id: 594,
    name: { 'en-us': 'Remodeling - Basements' },
    icon: 'icon-remodeling',
  },
  {
    id: 595,
    name: { 'en-us': 'Primary Care - Osteopathic Medicine' },
    icon: 'icon-health',
  },
  {
    id: 596,
    name: { 'en-us': 'Dermatology - Laser Skin Treatment' },
    icon: 'icon-health',
  },
  {
    id: 597,
    name: { 'en-us': 'Otolaryngology' },
    icon: 'icon-health',
  },
  {
    id: 599,
    name: { 'en-us': 'Skin & Body Care - Vein Treatment' },
    icon: 'icon-personal-care',
  },
  {
    id: 600,
    name: { 'en-us': 'Biohazard Remediation' },
    icon: 'icon-health',
  },
  {
    id: 604,
    name: { 'en-us': 'Eye Care - LASIK' },
    icon: 'icon-health',
  },
  {
    id: 605,
    name: { 'en-us': 'Auctions - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 606,
    name: { 'en-us': 'Decals - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 607,
    name: { 'en-us': 'Detailing - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 608,
    name: { 'en-us': 'Financing - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 609,
    name: { 'en-us': 'Storage - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 610,
    name: { 'en-us': 'Transport - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 611,
    name: { 'en-us': 'Window Tinting - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 612,
    name: { 'en-us': 'Air Conditioning - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 613,
    name: { 'en-us': 'Air Intake Systems - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 614,
    name: { 'en-us': 'Alternators - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 615,
    name: { 'en-us': 'Appraisals - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 616,
    name: { 'en-us': 'Babbitting - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 617,
    name: { 'en-us': 'Bodywork - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 618,
    name: { 'en-us': 'Brakes - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 619,
    name: { 'en-us': 'Bumpers - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 620,
    name: { 'en-us': 'Camshafts - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 621,
    name: { 'en-us': 'Car Dealers - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 622,
    name: { 'en-us': 'Carburetors - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 623,
    name: { 'en-us': 'Castings - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 624,
    name: { 'en-us': 'Chrome Work - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 625,
    name: { 'en-us': 'Clocks - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 626,
    name: { 'en-us': 'Clutches - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 627,
    name: { 'en-us': 'Coatings - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 628,
    name: { 'en-us': 'Consoles - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 629,
    name: { 'en-us': 'Convertible Top Repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 630,
    name: { 'en-us': 'Dashboards - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 631,
    name: { 'en-us': 'Differentials - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 632,
    name: { 'en-us': 'Distributors - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 633,
    name: { 'en-us': 'Electric Motor Repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 634,
    name: { 'en-us': 'Electrical - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 635,
    name: { 'en-us': 'Engine Repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 636,
    name: { 'en-us': 'Exhausts - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 637,
    name: { 'en-us': 'Fabricating - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 638,
    name: { 'en-us': 'Fuel System - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 639,
    name: { 'en-us': 'Gaskets - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 640,
    name: { 'en-us': 'Gearbox/Gears - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 641,
    name: { 'en-us': 'Generators - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 642,
    name: { 'en-us': 'Glass and Mirror - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 643,
    name: { 'en-us': 'Harmonic Balancers - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 644,
    name: { 'en-us': 'Headlights - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 645,
    name: { 'en-us': 'Heaters - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 646,
    name: { 'en-us': 'Hubcaps - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 647,
    name: { 'en-us': 'Import/Export Agents - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 648,
    name: { 'en-us': 'Instruments - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 649,
    name: { 'en-us': 'Insurance - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 650,
    name: { 'en-us': 'Keys - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 651,
    name: { 'en-us': 'Machining - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 652,
    name: { 'en-us': 'Magnetos - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 653,
    name: { 'en-us': 'Manifold Repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 654,
    name: { 'en-us': 'Oils/Lubricants - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 655,
    name: { 'en-us': 'Paint - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 656,
    name: { 'en-us': 'Parts Locators - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 657,
    name: { 'en-us': 'Pipes/Hoses/Cables/Lines - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 658,
    name: { 'en-us': 'Radiators - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 659,
    name: { 'en-us': 'Restorations - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 660,
    name: { 'en-us': 'Rust Removal - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 661,
    name: { 'en-us': 'Sheet Metal Repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 662,
    name: { 'en-us': 'Sound System Repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 663,
    name: { 'en-us': 'Starters - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 664,
    name: { 'en-us': 'Steering Mechanics - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 665,
    name: { 'en-us': 'Steering Wheels - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 666,
    name: { 'en-us': 'Suspension - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 667,
    name: { 'en-us': 'Transmission - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 668,
    name: { 'en-us': 'Trim - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 669,
    name: { 'en-us': 'Trunk repair - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 670,
    name: { 'en-us': 'Upholstery/Carpet - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 671,
    name: { 'en-us': 'Valves - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 672,
    name: { 'en-us': 'Water Pumps - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 673,
    name: { 'en-us': 'Welding - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 674,
    name: { 'en-us': 'Wheels and Tires - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 675,
    name: { 'en-us': 'Woodwork - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 676,
    name: { 'en-us': 'Engine Modification - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 677,
    name: { 'en-us': 'Interior Modification - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 678,
    name: { 'en-us': 'Exterior Modification - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 679,
    name: { 'en-us': 'Wheels and Tires - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 680,
    name: { 'en-us': 'Exhausts - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 681,
    name: { 'en-us': 'Suspension - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 682,
    name: { 'en-us': 'Brakes - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 683,
    name: { 'en-us': 'Transmission - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 684,
    name: { 'en-us': 'Ignition Systems - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 685,
    name: { 'en-us': 'Cooking Classes' },
    icon: 'icon-food',
  },
  {
    id: 686,
    name: { 'en-us': 'Chassis - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 687,
    name: { 'en-us': 'Custom Painting - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 688,
    name: { 'en-us': 'Car Customization  - Custom Car' },
    icon: 'icon-automotive',
  },
  {
    id: 690,
    name: { 'en-us': 'Title Services - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 692,
    name: { 'en-us': 'Service - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 694,
    name: { 'en-us': 'Oriental Rug Cleaning' },
    icon: 'icon-fabric',
  },
  {
    id: 696,
    name: { 'en-us': 'Imaging - Radiology' },
    icon: 'icon-health',
  },
  {
    id: 697,
    name: { 'en-us': 'Website Design & Development' },
    icon: 'icon-design',
  },
  {
    id: 698,
    name: { 'en-us': 'Graphic Design' },
    icon: 'icon-design',
  },
  {
    id: 699,
    name: { 'en-us': 'Banking/Credit Unions' },
    icon: 'icon-list',
  },
  {
    id: 700,
    name: { 'en-us': 'RV Sales & Service' },
    icon: 'icon-automotive',
  },
  {
    id: 701,
    name: { 'en-us': 'Remodeling - Modular & Mobile Home' },
    icon: 'icon-remodeling',
  },
  {
    id: 702,
    name: { 'en-us': 'Landscaping - Lighting' },
    icon: 'icon-landscaping',
  },
  {
    id: 703,
    name: { 'en-us': 'Concrete - Stamped & Decorative' },
    icon: 'icon-remodeling',
  },
  {
    id: 704,
    name: { 'en-us': 'Fencing - Driveway Gates' },
    icon: 'icon-remodeling',
  },
  {
    id: 705,
    name: { 'en-us': 'Hospitalist' },
    icon: 'icon-health',
  },
  {
    id: 706,
    name: { 'en-us': 'Health Insurance - Brokers' },
    icon: 'icon-health',
  },
  {
    id: 707,
    name: { 'en-us': 'Telemedicine' },
    icon: 'icon-health',
  },
  {
    id: 708,
    name: { 'en-us': 'Accessories - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 709,
    name: { 'en-us': 'Alarms - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 710,
    name: { 'en-us': 'Inspections - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 711,
    name: { 'en-us': 'Radio Service - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 712,
    name: { 'en-us': 'Sales - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 713,
    name: { 'en-us': 'Retail Clinic' },
    icon: 'icon-health',
  },
  {
    id: 714,
    name: { 'en-us': 'Therapy/Respite Camps' },
    icon: 'icon-health',
  },
  {
    id: 717,
    name: { 'en-us': 'Pediatrics - Neurosurgery' },
    icon: 'icon-health',
  },
  {
    id: 718,
    name: { 'en-us': 'Pet Bakeries' },
    icon: 'icon-pets',
  },
  {
    id: 719,
    name: { 'en-us': 'Animal Burial/Cremation' },
    icon: 'icon-pets',
  },
  {
    id: 720,
    name: { 'en-us': 'Aquariums' },
    icon: 'icon-water',
  },
  {
    id: 721,
    name: { 'en-us': 'Animal Rescues/Shelters' },
    icon: 'icon-pets',
  },
  {
    id: 722,
    name: { 'en-us': 'Pet Stores' },
    icon: 'icon-pets',
  },
  {
    id: 723,
    name: { 'en-us': 'Animal Breeders/Brokers' },
    icon: 'icon-pets',
  },
  {
    id: 724,
    name: { 'en-us': 'Generator' },
    icon: 'icon-electrical',
  },
  {
    id: 725,
    name: { 'en-us': 'Apartments' },
    icon: 'icon-home-exterior',
  },
  {
    id: 726,
    name: { 'en-us': 'Heating Oil' },
    icon: 'icon-hvac',
  },
  {
    id: 727,
    name: { 'en-us': 'Guns' },
    icon: 'icon-list',
  },
  {
    id: 728,
    name: { 'en-us': 'Life Coaches' },
    icon: 'icon-list',
  },
  {
    id: 729,
    name: { 'en-us': 'Credit Repair' },
    icon: 'icon-list',
  },
  {
    id: 730,
    name: { 'en-us': 'Notary' },
    icon: 'icon-list',
  },
  {
    id: 731,
    name: { 'en-us': 'Career Coach' },
    icon: 'icon-list',
  },
  {
    id: 732,
    name: { 'en-us': 'Medical Spa' },
    icon: 'icon-health',
  },
  {
    id: 733,
    name: { 'en-us': 'Central Vacuum Cleaning' },
    icon: 'icon-hvac',
  },
  {
    id: 734,
    name: { 'en-us': 'Patios' },
    icon: 'icon-health',
  },
  {
    id: 735,
    name: { 'en-us': 'Alternative Med. - Homeopathy' },
    icon: 'icon-health',
  },
  {
    id: 736,
    name: { 'en-us': 'Pool Sales Construction & Installation' },
    icon: 'icon-home-exterior',
  },
  {
    id: 737,
    name: { 'en-us': 'Cancer - Radiation Oncology' },
    icon: 'icon-health',
  },
  {
    id: 738,
    name: { 'en-us': 'Cancer - Surgical Oncology' },
    icon: 'icon-health',
  },
  {
    id: 739,
    name: { 'en-us': 'Cardiovascular Surgery - Vascular' },
    icon: 'icon-health',
  },
  {
    id: 740,
    name: { 'en-us': 'Ear, Nose & Throat - Facial Plastics' },
    icon: 'icon-health',
  },
  {
    id: 741,
    name: { 'en-us': 'Ear, Nose & Throat - Head & Neck' },
    icon: 'icon-health',
  },
  {
    id: 742,
    name: { 'en-us': 'Ear, Nose & Throat - Laryngology' },
    icon: 'icon-health',
  },
  {
    id: 743,
    name: { 'en-us': 'Ear, Nose & Throat - Otology/Neurotology' },
    icon: 'icon-health',
  },
  {
    id: 744,
    name: { 'en-us': 'Endocrinology - Surgery' },
    icon: 'icon-health',
  },
  {
    id: 745,
    name: { 'en-us': 'Eye Care - Oculoplastics' },
    icon: 'icon-health',
  },
  {
    id: 746,
    name: { 'en-us': 'Fitness - Studios' },
    icon: 'icon-health',
  },
  {
    id: 747,
    name: { 'en-us': 'Foot & Ankle Care - Podiatric Surgery' },
    icon: 'icon-health',
  },
  {
    id: 749,
    name: { 'en-us': 'Guidance - Elder Law' },
    icon: 'icon-briefcase',
  },
  {
    id: 750,
    name: { 'en-us': 'Guidance - End of Life Planning' },
    icon: 'icon-health',
  },
  {
    id: 751,
    name: { 'en-us': 'Guidance - Financial & Estate Planning' },
    icon: 'icon-briefcase',
  },
  {
    id: 752,
    name: { 'en-us': 'Guidance - Geriatric Care Managers' },
    icon: 'icon-briefcase',
  },
  {
    id: 753,
    name: { 'en-us': 'Guidance - Health Insurance Counselors' },
    icon: 'icon-health',
  },
  {
    id: 754,
    name: { 'en-us': 'Home Care - Personal Care Attendants' },
    icon: 'icon-health',
  },
  {
    id: 755,
    name: { 'en-us': 'Home Healthcare - Certified Nursing Assistants' },
    icon: 'icon-health',
  },
  {
    id: 756,
    name: { 'en-us': 'Home Healthcare - Home Health Aids' },
    icon: 'icon-health',
  },
  {
    id: 757,
    name: { 'en-us': 'Hospitals - Long Term Acute Care' },
    icon: 'icon-health',
  },
  {
    id: 758,
    name: { 'en-us': 'Infectious Diseases - HIV' },
    icon: 'icon-health',
  },
  {
    id: 759,
    name: { 'en-us': 'Infectious Diseases - Pediatric' },
    icon: 'icon-health',
  },
  {
    id: 760,
    name: { 'en-us': 'Lab Services - Genetic' },
    icon: 'icon-health',
  },
  {
    id: 761,
    name: { 'en-us': 'Lab Services - Paternity / DNA Testing' },
    icon: 'icon-health',
  },
  {
    id: 762,
    name: { 'en-us': 'Longterm Care - Retirement Facilities' },
    icon: 'icon-health',
  },
  {
    id: 763,
    name: { 'en-us': 'Longterm Care - Alzheimer\'s Care Facilities' },
    icon: 'icon-health',
  },
  {
    id: 764,
    name: { 'en-us': 'Longterm Care - Long Term Acute Care' },
    icon: 'icon-health',
  },
  {
    id: 765,
    name: { 'en-us': 'Longterm Care - Senior Move Managers' },
    icon: 'icon-health',
  },
  {
    id: 766,
    name: { 'en-us': 'Longterm Care - Skilled Nursing Facility' },
    icon: 'icon-health',
  },
  {
    id: 767,
    name: { 'en-us': 'Lung/Pulmonology - Critical Care' },
    icon: 'icon-health',
  },
  {
    id: 768,
    name: { 'en-us': 'Mental Health - General' },
    icon: 'icon-health',
  },
  {
    id: 769,
    name: { 'en-us': 'Mental Health - Geriatric' },
    icon: 'icon-health',
  },
  {
    id: 771,
    name: { 'en-us': 'Mental Health - Neuropsychology / Testing' },
    icon: 'icon-health',
  },
  {
    id: 772,
    name: { 'en-us': 'Mental Health - Pediatrics / Adolescent' },
    icon: 'icon-health',
  },
  {
    id: 773,
    name: { 'en-us': 'Neurology - Pain Management' },
    icon: 'icon-health',
  },
  {
    id: 774,
    name: { 'en-us': 'Neurosurgery - Pediatric ' },
    icon: 'icon-health',
  },
  {
    id: 775,
    name: { 'en-us': 'Occupational Therapy - Geriatric' },
    icon: 'icon-health',
  },
  {
    id: 776,
    name: { 'en-us': 'Orthopedics - Oncology' },
    icon: 'icon-health',
  },
  {
    id: 777,
    name: { 'en-us': 'Orthopedics - Sports Medicine' },
    icon: 'icon-health',
  },
  {
    id: 778,
    name: { 'en-us': 'Palliative Care - Geriatric / Adult' },
    icon: 'icon-health',
  },
  {
    id: 779,
    name: { 'en-us': 'Palliative Care - Pain Management / General' },
    icon: 'icon-health',
  },
  {
    id: 780,
    name: { 'en-us': 'Palliative Care - Pediatric' },
    icon: 'icon-health',
  },
  {
    id: 781,
    name: { 'en-us': 'Palliative Care - Physical Therapy' },
    icon: 'icon-health',
  },
  {
    id: 782,
    name: { 'en-us': 'Pathology - Dermatopathology' },
    icon: 'icon-health',
  },
  {
    id: 783,
    name: { 'en-us': 'Pathology - General' },
    icon: 'icon-health',
  },
  {
    id: 784,
    name: { 'en-us': 'Pediatrics - Developmental' },
    icon: 'icon-health',
  },
  {
    id: 785,
    name: { 'en-us': 'Pediatrics - Emergency and Critical Care' },
    icon: 'icon-health',
  },
  {
    id: 786,
    name: { 'en-us': 'Personal Services - Meal Delivery' },
    icon: 'icon-health',
  },
  {
    id: 787,
    name: { 'en-us': 'Personal Services - Medical Transportation' },
    icon: 'icon-health',
  },
  {
    id: 788,
    name: { 'en-us': 'Pharmacies - Compounding' },
    icon: 'icon-health',
  },
  {
    id: 789,
    name: { 'en-us': 'Physicians Assistant' },
    icon: 'icon-health',
  },
  {
    id: 790,
    name: { 'en-us': 'Plastic Surgery - Craniofacial' },
    icon: 'icon-health',
  },
  {
    id: 791,
    name: { 'en-us': 'Plastic Surgery - General' },
    icon: 'icon-health',
  },
  {
    id: 792,
    name: { 'en-us': 'Radiology - Breast Imaging' },
    icon: 'icon-health',
  },
  {
    id: 793,
    name: { 'en-us': 'Radiology - Interventional / Vascular' },
    icon: 'icon-health',
  },
  {
    id: 794,
    name: { 'en-us': 'Radiology - Neurologic Imaging' },
    icon: 'icon-health',
  },
  {
    id: 795,
    name: { 'en-us': 'Radiology - Nuclear Medicine' },
    icon: 'icon-health',
  },
  {
    id: 796,
    name: { 'en-us': 'Rehabilitation - Geriatric' },
    icon: 'icon-health',
  },
  {
    id: 797,
    name: { 'en-us': 'Rehabilitation - Pediatric' },
    icon: 'icon-health',
  },
  {
    id: 798,
    name: { 'en-us': 'Rehabilitation - Sports' },
    icon: 'icon-health',
  },
  {
    id: 799,
    name: { 'en-us': 'Skin & Body Care - Estheticians' },
    icon: 'icon-health',
  },
  {
    id: 800,
    name: { 'en-us': 'Skin & Body Care - General' },
    icon: 'icon-health',
  },
  {
    id: 801,
    name: { 'en-us': 'Skin & Body Care - Laser Therapy and Hair Removal' },
    icon: 'icon-health',
  },
  {
    id: 802,
    name: { 'en-us': 'Skin & Body Care - Permanent Makeup' },
    icon: 'icon-health',
  },
  {
    id: 803,
    name: { 'en-us': 'Skin & Body Care - Tattoo Removal' },
    icon: 'icon-health',
  },
  {
    id: 804,
    name: { 'en-us': 'Sleep Medicine - Surgery' },
    icon: 'icon-health',
  },
  {
    id: 805,
    name: { 'en-us': 'Sleep Medicine - Testing Facilities' },
    icon: 'icon-health',
  },
  {
    id: 806,
    name: { 'en-us': 'Speech Therapy - Pediatric' },
    icon: 'icon-health',
  },
  {
    id: 807,
    name: { 'en-us': 'Surgery - Bariatric Surgery' },
    icon: 'icon-health',
  },
  {
    id: 808,
    name: { 'en-us': 'Surgery - Breast Surgery' },
    icon: 'icon-health',
  },
  {
    id: 809,
    name: { 'en-us': 'Surgery - Burns' },
    icon: 'icon-health',
  },
  {
    id: 810,
    name: { 'en-us': 'Surgery - Colon and Rectal Surgery' },
    icon: 'icon-health',
  },
  {
    id: 811,
    name: { 'en-us': 'Surgery - Trauma/Critical Care' },
    icon: 'icon-health',
  },
  {
    id: 812,
    name: { 'en-us': 'Surgery Centers' },
    icon: 'icon-health',
  },
  {
    id: 813,
    name: { 'en-us': 'Toxicology' },
    icon: 'icon-health',
  },
  {
    id: 814,
    name: { 'en-us': 'Transplant - Cardiology' },
    icon: 'icon-health',
  },
  {
    id: 815,
    name: { 'en-us': 'Transplant - Hepatology' },
    icon: 'icon-health',
  },
  {
    id: 816,
    name: { 'en-us': 'Transplant - Medicine' },
    icon: 'icon-health',
  },
  {
    id: 817,
    name: { 'en-us': 'Urology - Reconstructive and Rejuvenation' },
    icon: 'icon-health',
  },
  {
    id: 818,
    name: { 'en-us': 'Weight Management - Bariatric Surgery' },
    icon: 'icon-health',
  },
  {
    id: 819,
    name: { 'en-us': 'Women\'s Services - Gynecological Oncology' },
    icon: 'icon-health',
  },
  {
    id: 820,
    name: { 'en-us': 'Women\'s Services - Maternal Fetal Medicine' },
    icon: 'icon-health',
  },
  {
    id: 821,
    name: { 'en-us': 'Women\'s Services - OBGYN- Reconstructive' },
    icon: 'icon-health',
  },
  {
    id: 822,
    name: { 'en-us': 'Accessories - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 823,
    name: { 'en-us': 'Air Conditioning - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 824,
    name: { 'en-us': 'Air Intake Systems' },
    icon: 'icon-automotive',
  },
  {
    id: 825,
    name: { 'en-us': 'Alternators' },
    icon: 'icon-automotive',
  },
  {
    id: 826,
    name: { 'en-us': 'Auto Alarms' },
    icon: 'icon-automotive',
  },
  {
    id: 827,
    name: { 'en-us': 'Auto Appraisals' },
    icon: 'icon-automotive',
  },
  {
    id: 828,
    name: { 'en-us': 'Auto Auctions' },
    icon: 'icon-automotive',
  },
  {
    id: 829,
    name: { 'en-us': 'Auto Decals' },
    icon: 'icon-automotive',
  },
  {
    id: 830,
    name: { 'en-us': 'Auto Financing' },
    icon: 'icon-automotive',
  },
  {
    id: 831,
    name: { 'en-us': 'Auto Glass and Mirrors' },
    icon: 'icon-automotive',
  },
  {
    id: 832,
    name: { 'en-us': 'Auto Inspections' },
    icon: 'icon-automotive',
  },
  {
    id: 833,
    name: { 'en-us': 'Auto Insurance' },
    icon: 'icon-automotive',
  },
  {
    id: 834,
    name: { 'en-us': 'Auto Radiators' },
    icon: 'icon-automotive',
  },
  {
    id: 835,
    name: { 'en-us': 'Auto Sales' },
    icon: 'icon-automotive',
  },
  {
    id: 836,
    name: { 'en-us': 'Auto Storage' },
    icon: 'icon-automotive',
  },
  {
    id: 837,
    name: { 'en-us': 'Auto Transport' },
    icon: 'icon-automotive',
  },
  {
    id: 838,
    name: { 'en-us': 'Auto Welding' },
    icon: 'icon-automotive',
  },
  {
    id: 839,
    name: { 'en-us': 'Bodywork' },
    icon: 'icon-automotive',
  },
  {
    id: 840,
    name: { 'en-us': 'Brakes' },
    icon: 'icon-automotive',
  },
  {
    id: 841,
    name: { 'en-us': 'Bumpers' },
    icon: 'icon-automotive',
  },
  {
    id: 842,
    name: { 'en-us': 'Camshafts' },
    icon: 'icon-automotive',
  },
  {
    id: 843,
    name: { 'en-us': 'Car Customization' },
    icon: 'icon-automotive',
  },
  {
    id: 844,
    name: { 'en-us': 'Carburetors' },
    icon: 'icon-automotive',
  },
  {
    id: 845,
    name: { 'en-us': 'Castings' },
    icon: 'icon-automotive',
  },
  {
    id: 846,
    name: { 'en-us': 'Chassis' },
    icon: 'icon-automotive',
  },
  {
    id: 847,
    name: { 'en-us': 'Chrome Work' },
    icon: 'icon-automotive',
  },
  {
    id: 848,
    name: { 'en-us': 'Clutches' },
    icon: 'icon-automotive',
  },
  {
    id: 849,
    name: { 'en-us': 'Coatings' },
    icon: 'icon-automotive',
  },
  {
    id: 850,
    name: { 'en-us': 'Convertible Top Repair' },
    icon: 'icon-automotive',
  },
  {
    id: 851,
    name: { 'en-us': 'Dashboards' },
    icon: 'icon-automotive',
  },
  {
    id: 852,
    name: { 'en-us': 'Detailing' },
    icon: 'icon-automotive',
  },
  {
    id: 853,
    name: { 'en-us': 'Differentials' },
    icon: 'icon-automotive',
  },
  {
    id: 854,
    name: { 'en-us': 'Distributors' },
    icon: 'icon-automotive',
  },
  {
    id: 855,
    name: { 'en-us': 'Electrical - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 856,
    name: { 'en-us': 'Engine Repair' },
    icon: 'icon-automotive',
  },
  {
    id: 857,
    name: { 'en-us': 'Exhausts' },
    icon: 'icon-automotive',
  },
  {
    id: 858,
    name: { 'en-us': 'Fabricating' },
    icon: 'icon-automotive',
  },
  {
    id: 859,
    name: { 'en-us': 'Fuel System' },
    icon: 'icon-automotive',
  },
  {
    id: 860,
    name: { 'en-us': 'Gaskets' },
    icon: 'icon-automotive',
  },
  {
    id: 861,
    name: { 'en-us': 'Gearbox/Gears' },
    icon: 'icon-automotive',
  },
  {
    id: 862,
    name: { 'en-us': 'Generators' },
    icon: 'icon-automotive',
  },
  {
    id: 863,
    name: { 'en-us': 'Headlights' },
    icon: 'icon-automotive',
  },
  {
    id: 864,
    name: { 'en-us': 'Heaters - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 865,
    name: { 'en-us': 'Hubcaps' },
    icon: 'icon-automotive',
  },
  {
    id: 866,
    name: { 'en-us': 'Ignition Systems' },
    icon: 'icon-automotive',
  },
  {
    id: 867,
    name: { 'en-us': 'Import/Export Agents' },
    icon: 'icon-automotive',
  },
  {
    id: 868,
    name: { 'en-us': 'Keys - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 869,
    name: { 'en-us': 'Machining' },
    icon: 'icon-automotive',
  },
  {
    id: 870,
    name: { 'en-us': 'Manifold Repair' },
    icon: 'icon-automotive',
  },
  {
    id: 871,
    name: { 'en-us': 'Oils/Lubricants' },
    icon: 'icon-automotive',
  },
  {
    id: 872,
    name: { 'en-us': 'Paint - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 873,
    name: { 'en-us': 'Parts Locators - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 874,
    name: { 'en-us': 'Pipes/Hoses/Cables/Lines' },
    icon: 'icon-automotive',
  },
  {
    id: 875,
    name: { 'en-us': 'Radio Service' },
    icon: 'icon-automotive',
  },
  {
    id: 876,
    name: { 'en-us': 'Restorations - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 877,
    name: { 'en-us': 'Rust Removal' },
    icon: 'icon-automotive',
  },
  {
    id: 878,
    name: { 'en-us': 'Sheet Metal Repair' },
    icon: 'icon-automotive',
  },
  {
    id: 879,
    name: { 'en-us': 'Sound System Repair' },
    icon: 'icon-automotive',
  },
  {
    id: 880,
    name: { 'en-us': 'Starters' },
    icon: 'icon-automotive',
  },
  {
    id: 881,
    name: { 'en-us': 'Steering Mechanics' },
    icon: 'icon-automotive',
  },
  {
    id: 882,
    name: { 'en-us': 'Steering Wheels' },
    icon: 'icon-automotive',
  },
  {
    id: 883,
    name: { 'en-us': 'Suspension' },
    icon: 'icon-automotive',
  },
  {
    id: 884,
    name: { 'en-us': 'Title Services' },
    icon: 'icon-automotive',
  },
  {
    id: 885,
    name: { 'en-us': 'Transmission' },
    icon: 'icon-automotive',
  },
  {
    id: 886,
    name: { 'en-us': 'Trim - Classic Cars' },
    icon: 'icon-automotive',
  },
  {
    id: 887,
    name: { 'en-us': 'Trunk repair' },
    icon: 'icon-automotive',
  },
  {
    id: 888,
    name: { 'en-us': 'Upholstery/Carpet - Auto' },
    icon: 'icon-automotive',
  },
  {
    id: 889,
    name: { 'en-us': 'Valves' },
    icon: 'icon-automotive',
  },
  {
    id: 890,
    name: { 'en-us': 'Water Pumps' },
    icon: 'icon-automotive',
  },
  {
    id: 891,
    name: { 'en-us': 'Wheels and Tires' },
    icon: 'icon-automotive',
  },
  {
    id: 892,
    name: { 'en-us': 'Window Tinting' },
    icon: 'icon-automotive',
  },
  {
    id: 893,
    name: { 'en-us': 'Seatbelts' },
    icon: 'icon-automotive',
  },
  {
    id: 894,
    name: { 'en-us': 'Motorcycle Restoration' },
    icon: 'icon-automotive',
  },
  {
    id: 895,
    name: { 'en-us': 'Audio/Video Equipment Rental' },
    icon: 'icon-camera',
  },
  {
    id: 896,
    name: { 'en-us': 'Dog Parks' },
    icon: 'icon-pets',
  },
  {
    id: 897,
    name: { 'en-us': 'Horseback Riding Lessons' },
    icon: 'icon-pets',
  },
  {
    id: 898,
    name: { 'en-us': 'Stables/Horse Boarding' },
    icon: 'icon-pets',
  },
  {
    id: 899,
    name: { 'en-us': 'Locally Grown Food Supplier' },
    icon: 'icon-food',
  },
  {
    id: 900,
    name: { 'en-us': 'Outdoor Kitchens and Living' },
    icon: 'icon-home-exterior',
  },
  {
    id: 901,
    name: { 'en-us': 'Patio' },
    icon: 'icon-home-exterior',
  },
  {
    id: 903,
    name: { 'en-us': 'Concrete / Stamped & Decorative' },
    icon: 'icon-home-exterior',
  },
  {
    id: 905,
    name: { 'en-us': 'Landscaping / Lighting' },
    icon: 'icon-electrical',
  },
  {
    id: 907,
    name: { 'en-us': 'Fencing / Driveway Gates' },
    icon: 'icon-home-exterior',
  },
];

const categoryUtils = {
  fetchCategoryProperty(categoryId, property) {
    return result(find(categories, { id: categoryId }) || find(categories, { id: -1 }), property);
  },
  fetchAllCategories() {
    return categories;
  },
};

export default categoryUtils;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/categoryUtils.js